import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React from 'react';

import { L } from '@lib';

const { Option } = Select;

interface IProps {
  disabled?: boolean;
  hideFirstOption?: boolean;
  hidePaid?: boolean;
  hideReady?: boolean;
  hideApproval?: boolean;
  status?: string;
  className?: string;
  showCancel?: boolean;
  style?: React.CSSProperties | undefined;
  width?: string | number;
  size?: 'small' | 'middle' | 'large';
  onChange?:
    | ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void)
    | undefined;
}

export const OrderStatusSelect: React.FC<IProps> = ({
  disabled = false,
  showCancel = false,
  hideFirstOption = false,
  hidePaid = false,
  hideReady = false,
  hideApproval = false,
  status,
  style = { minWidth: 200 },
  width,
  className,
  size = 'middle',
  onChange,
}) => {
  const showCancelOption =
    showCancel || (status && status !== 'Completed' && status !== 'Ready' && status !== 'Paid');

  const mergedStyle = {
    ...style,
    ...(width && { width, minWidth: 'auto' }), // Override width and remove minWidth when width is provided
  };

  return (
    <Select
      disabled={disabled}
      className={className}
      style={mergedStyle}
      size={size}
      defaultValue="All"
      value={status}
      onChange={onChange}
    >
      {!hideFirstOption && <Option value={undefined}>{L('All')}</Option>}
      {!hideApproval && <Option value="Approval">{L('Estimate')}</Option>}
      <Option value="Todo">{L('To do')}</Option>
      <Option value="PartsNotOrdered">{L('To do - Parts not ordered')}</Option>
      <Option value="PartsOrdered">{L('To do - Parts ordered')}</Option>
      <Option value="ReadyToGo">{L('To do - Ready to go')}</Option>
      <Option value="InProgress">{L('In progress')}</Option>
      <Option value="OnHold">{L('On hold')}</Option>
      {showCancelOption && <Option value="Canceled">{L('Cancelled')}</Option>}
      <Option value="Completed">{L('Service completed')}</Option>
      {!hideReady && <Option value="Ready">{L('Ready for payment')}</Option>}
      {!hidePaid && <Option value="Paid">{L('Paid')}</Option>}
    </Select>
  );
};
